var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.label)+" ")]),_c('span',{staticClass:"value-to-highlight"},[_vm._v(_vm._s(_vm.value)+" "+_vm._s(_vm.$t("orders.creation.packs"))+" ")]),(_vm.symbol)?_c('span',{staticClass:"value-to-highlight"},[_vm._v(_vm._s(_vm.symbol))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }